import { createBrowserRouter, Navigate, Outlet } from 'react-router';
import { AppShell } from './components/layout/app-shell';
import { Spinner } from './components/ui/feedback';
import { AccountsPage } from './features/accounts/accounts-page';
import { AnalyticsPage } from './features/analytics/analytics-page';
import { InvitePage } from './features/auth/invite-page';
import { LoginPage } from './features/auth/login-page';
import { SetupPage } from './features/auth/setup-page';
import { DashboardPage } from './features/dashboard/dashboard-page';
import { DuplicatesPage } from './features/duplicates/duplicates-page';
import { OutreachPage } from './features/outreach/outreach-page';
import { PeoplePage } from './features/people/people-page';
import { ProjectPage } from './features/research/project-page';
import { WizardPage } from './features/research/wizard-page';
import { SettingsPage } from './features/settings/settings-page';
import { SourcesPage } from './features/sources/sources-page';
import { useAuthStatus } from './lib/session';

/** Sends the user to first-run setup or sign-in before any workspace route renders. */
function RequireAuth() {
  const status = useAuthStatus();

  if (status.isPending) {
    return (
      <div className="flex min-h-dvh items-center justify-center text-muted-foreground">
        <Spinner className="h-5 w-5" />
      </div>
    );
  }
  if (status.data?.setupRequired) return <Navigate to="/setup" replace />;
  if (!status.data?.authenticated) return <Navigate to="/login" replace />;
  return <Outlet />;
}

export const router = createBrowserRouter([
  { path: '/login', element: <LoginPage /> },
  { path: '/setup', element: <SetupPage /> },
  { path: '/invite/:token', element: <InvitePage /> },
  {
    element: <RequireAuth />,
    children: [
      {
        element: <AppShell />,
        children: [
          { index: true, element: <DashboardPage /> },
          { path: 'research/new', element: <WizardPage /> },
          { path: 'research/:id', element: <ProjectPage /> },
          { path: 'accounts', element: <AccountsPage /> },
          { path: 'people', element: <PeoplePage /> },
          { path: 'analytics', element: <AnalyticsPage /> },
          { path: 'outreach', element: <OutreachPage /> },
          { path: 'duplicates', element: <DuplicatesPage /> },
          { path: 'sources', element: <SourcesPage /> },
          { path: 'settings', element: <SettingsPage /> },
        ],
      },
    ],
  },
  { path: '*', element: <Navigate to="/" replace /> },
]);
